const isAmount = (value) =>
  (typeof value === 'number' || (typeof value === 'string' && /^\d+(\.\d+)?$/.test(value))) &&
  Number.isFinite(Number(value)) &&
  Number(value) >= 0;

const isDate = (value) => {
  if (value === null) return true;
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const date = new Date(`${value}T00:00:00Z`);
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value;
};

// Invalid restrictions or monetary fields must not turn into a broader or unconditional offer.
export const parseCouponSummary = (data) => {
  if (
    !data ||
    typeof data.code !== 'string' || !/^[A-Z0-9]{5}$/.test(data.code) ||
    typeof data.percentage !== 'boolean' ||
    !isAmount(data.value) ||
    (data.percentage && Number(data.value) > 100) ||
    typeof data.currency !== 'string' || !/^[A-Z]{3}$/.test(data.currency) ||
    !isAmount(data.required_minimum_value) ||
    !(data.product_ids === null || (
      Array.isArray(data.product_ids) &&
      data.product_ids.every((id) => typeof id === 'string' && id.length > 0)
    )) ||
    !Array.isArray(data.free_shipping_types) ||
    !data.free_shipping_types.every((type) => Number.isInteger(type) && type >= 0) ||
    !isDate(data.ends_at)
  ) {
    throw new Error('Unable to verify this coupon. Please try again.');
  }
  return {
    code: data.code,
    isPercentage: data.percentage,
    value: Number(data.value),
    currency: data.currency,
    // The backend treats an empty restriction as unrestricted too.
    productIds: data.product_ids?.length ? data.product_ids : null,
    requiredMinimumValue: Number(data.required_minimum_value),
    freeShippingTypes: data.free_shipping_types,
    endsAt: data.ends_at,
  };
};
